module.exports = __webpack_public_path__ + "d552c85cfc162c5ce06f596bc4205b41.pdf";